export default {
  data: () => ({}),
  methods: {
    executeAutomations (taskId, automations) {
      // Separe em variáveis
      const sendMessageItems = automations.filter(item => item.action === 'send_message')
      const createTaskItems = automations.filter(item => item.action === 'create_task')
      if (sendMessageItems.length > 0) {
        this.$store.commit('automationMessage/change_values', {dialog: true, taskId: taskId, tasktemplateAutomationIds: sendMessageItems.map(i => i.id)})
      }

      if (createTaskItems.length > 0) {
        this.$store.commit('automationCreateTask/change_values', {dialog: true, taskId: taskId, tasktemplateAutomationIds: createTaskItems.map(i => i.id)})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/automation.js